<template>
    <div class="box">
        <!-- <el-table :data="tableData" border empty-text="暂无数据" style="width: 100%">
          <el-table-column type="index" :label="'序号'" width="50" align="center"> </el-table-column>
          <el-table-column prop="chargeItem" :label="'缴费类型'" width="120" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div>{{ chargeItemFormat(scope.row.chargeItem) }}</div>
				</template>
			  </el-table-column>
          <el-table-column prop="chargeAmount" :label="'金额（元）'" :show-overflow-tooltip="true" width="120" align="center">
				<template slot-scope="scope">
					 <div>
						<template v-if="vo.isFree==0&&scope.row.chargeItem==0"><div></div></template>
						<template v-else>
							<el-input v-if="canEdit" v-model="scope.row.chargeAmount" placeholder="请输入" @change="changeAmount($event, scope.row)"></el-input>
							<div v-else>{{ scope.row.chargeAmount }}</div>
						</template>
					</div>
				</template>
			  </el-table-column>
          <el-table-column prop="invoiceNo" :label="'票据编号'" :show-overflow-tooltip="true" align="center">
					<template slot-scope="scope">
					 <div>
						<template v-if="vo.isFree==0&&scope.row.chargeItem==0"><div></div></template>
						<template v-else>
							<el-input v-if="canEdit" v-model="scope.row.invoiceNo" placeholder="请输入"></el-input>
							<div v-else>{{ scope.row.invoiceNo }}</div>
						</template>
					</div>
				</template>
				</el-table-column>
          <el-table-column prop="file" :label="'缴费凭证'" :show-overflow-tooltip="true" width="250" align="center">
				<template slot-scope="scope">
					<div>
						<template v-if="vo.isFree==0&&scope.row.chargeItem==0"><div></div></template>
						<template v-else>
							<span v-if="canEdit">
								<template v-if="scope.row.passenger.attachments.length==0">
									<el-upload v-if="canEdit" class="upload-demo" action="" :show-file-list="false" :limit="1" :auto-upload="false" :on-remove="handleRemove" :on-change="handleUploadChange" :file-list="fileList">
									  <el-link v-if="scope.row.passenger.attachments.length==0" :underline="false" @click="uploadItem(scope.row)">上传</el-link>
									</el-upload>
									<div v-else>
										<el-link v-if="scope.row.passenger.attachments.length" :underline="false" @click="attachClick(scope.row)">{{ scope.row.passenger.attachments[0].fileName }}</el-link>
									</div>
								</template>
								<template v-else>
										<div style="display: flex;align-items: center;justify-content: space-between;padding-right: 5px;">
											<div style="flex: 1;overflow: hidden; text-overflow: ellipsis; display: block; -webkit-line-clamp: 1; -webkit-box-orient: vertical;" @click="attachClick(scope.row)">{{ scope.row.passenger.attachments[0].fileName }}</div>
											<i class="el-icon-close" @click="deleteFile(scope.row)"></i>
										</div>
								</template>

							</span>
							<span v-else>
								<el-link v-if="scope.row.passenger.attachments.length" :underline="false" @click="attachClick(scope.row)">{{ scope.row.passenger.attachments[0].fileName }}</el-link>
							</span>
						</template>
					</div>
            </template>
			  </el-table-column>
        </el-table> -->
        <!-- <inner-table id="innerTuitionPayment" ref="tuitionPaymentList" :listviewurl="'student.tuitionPayment.list'" :can-edit="0" :can-delete="0" :exclude-fields="'enrollmentStatus,isFree,createBy'" :link-prop-name="'studentId'" /> -->
        <table v-if="tableData.length != 0" border="0" class="el-table__body">
            <tbody v-for="(item, index) in tableData" :key="index">
                <tr>
                    <td colspan="24" style="vertical-align: middle; background-color: rgba(242, 245, 251); color: rgba(62, 86, 105)">{{ item.name }}</td>
                </tr>
                <tr>
                    <td colspan="1" style="text-align: center; vertical-align: middle">序号</td>
                    <td colspan="3" style="vertical-align: middle">缴费类型</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">金额（元）</td>
                    <td colspan="10" style="text-align: center; vertical-align: middle">票据编号</td>
                    <td colspan="4" style="text-align: center; vertical-align: middle">缴费日期</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">缴费凭证</td>
                </tr>
                <tr v-for="(item1, index1) in item.list" :key="index1">
                    <td colspan="1" style="text-align: center; vertical-align: middle">{{ index1 + 1 }}</td>
                    <td colspan="3" style="vertical-align: middle">{{ chargeItemFormat(item1.chargeItem) }}</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">{{ item1.chargeAmount }}</td>
                    <td colspan="10" style="text-align: center; vertical-align: middle">{{ item1.invoiceNo }}</td>
                    <td colspan="4" style="text-align: center; vertical-align: middle">{{ item1.createTime.slice(0, 16) }}</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">
                        <el-link v-if="item1.passenger.attachments && item1.passenger.attachments.length" :underline="false" @click="attachClick(item1)">{{ item1.passenger.attachments[0].fileName }}</el-link>
                    </td>
                </tr>
            </tbody>
        </table>
        <table v-else border="0" class="el-table__body">
            <tbody>
                <tr>
                    <td colspan="1" style="text-align: center; vertical-align: middle">序号</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">缴费类型</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">金额（元）</td>
                    <td colspan="10" style="text-align: center; vertical-align: middle">票据编号</td>
                    <td colspan="4" style="text-align: center; vertical-align: middle">缴费日期</td>
                    <td colspan="3" style="text-align: center; vertical-align: middle">缴费凭证</td>
                </tr>
                <tr>
                    <td colspan="24" style="text-align: center; color: #909399">暂无数据</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created: function () {
        this.getList()
    },
    mounted: function () {},
    methods: {
        chargeItemFormat(val) {
            if (val == 0) {
                return '学费'
            } else if (val == 1) {
                return '住宿费'
            } else if (val == 2) {
                return '书费'
            }
        },
        attachClick(row) {
            if (!row.passenger.attachments[0].id) return
            let file = row.passenger.attachments[0]
            window.open(`apigw/xsgl/freshmanTuitionPayment/downloadById?inline=true&attachIds=${file.id}&topdf=false`)
        },
        getList() {
            this.$http({
                method: 'post',
                url: '/xsgl/studentTuitionPayment/listdata?urlsearch=studentId:' + this.vo.studentId
            }).then((res) => {
                if (res.code === 'success') {
                    if (res.body.pageInfo.list.length != 0) {
                        res.body.pageInfo.list.forEach((a) => {
                            let name = a.schoolYear + '学年' + '第' + a.semester + '学期'
                            if (this.tableData.length == 0) {
                                this.tableData.push({ name: name, list: [] })
                            } else {
                                if (this.tableData.every((a) => a.name != name)) {
                                    this.tableData.push({ name: name, list: [] })
                                }
                            }
                        })
                        res.body.pageInfo.list.forEach((a) => {
                            let name = a.schoolYear + '学年' + '第' + a.semester + '学期'
                            this.tableData.forEach((b) => {
                                if (b.name == name) {
                                    b.list.push(a)
                                }
                            })
                        })
                    }
                }
            })
        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        },
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach((v) => {
                v.chargeItem = this.filterChargeItem(v.chargeItem)
            })
        },
        filterChargeItem(val) {
            if (val == '1') {
                return '学费'
            } else if (val == '2') {
                return '住宿费'
            } else if (val == '3') {
                return '书费'
            }
        }
    }
}
</script>

<style scoped>
.header {
    padding: 10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
    border: 1px solid #999;
}
table {
    border-collapse: collapse; /* 合并边框 */
    width: 100%;
}
table,
th,
td {
    border: 1px solid black; /* 设置边框 */
}
</style>
